import { render } from "./AddCraftModal.vue?vue&type=template&id=2850bd8f&scoped=true"
import script from "./AddCraftModal.vue?vue&type=script&lang=js"
export * from "./AddCraftModal.vue?vue&type=script&lang=js"

import "./AddCraftModal.vue?vue&type=style&index=0&id=2850bd8f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2850bd8f"]])

export default __exports__